module.exports = __webpack_public_path__ + "static/media/quiz3.d1acaf3b.png";